import * as React from 'react';
import './calendar.scss';
import { useNavigate } from 'react-router-dom';
import WithSideBarAndNavBar from '../../layouts/withSideBarAndNavBar/withSideBarAndNavBar';
import { EventClickArg, EventContentArg, formatDate } from '@fullcalendar/core';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { INITIAL_EVENTS } from './event-utils';
import Button from '../../common/button/button';
import { ReactComponent as Close } from '../../assets/images/close.svg';
import { ReactComponent as TrashIcon } from '../../assets/icons/trash.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/edit2.svg';
import { ReactComponent as EllipseIcon } from '../../assets/icons/ellipse.svg';

const Calendar: React.FC = () => {
    const navigate = useNavigate();
    const [viewEventModal, setViewEventModal] = React.useState<boolean>(false);
    const [selectedEvent, setSelectedEvent] = React.useState<EventClickArg>();

    const handleAddEvent = () => {
        navigate(`/calendar-add-event`);
    };

    const [xDir, setXDir] = React.useState<number>();
    const [yDir, setYDir] = React.useState<number>();

    document.documentElement.style.setProperty('--xDir', `${xDir}px`);
    document.documentElement.style.setProperty('--yDir', `${yDir}px`);

    const renderEventContent = (eventContent: EventContentArg) => {
        return (
            <div className="calendar__events">
                <div className="calendar__events__icon">
                    <EllipseIcon />
                </div>
                <div>{eventContent.event.title}</div>
            </div>
        );
    };

    const handleEventClick = (clickInfo: EventClickArg) => {
        console.log(clickInfo)

        const X = clickInfo.jsEvent.clientX - 800 // + Parent.scrollLeft - Parent.offsetLeft
        const Y = clickInfo.jsEvent.clientY - 500 // + Parent.scrollTop - Parent.offsetTop

        setXDir(X)
        setYDir(Y)

        setSelectedEvent(clickInfo);
        setViewEventModal(true);
    };

    const onCloseModal = () => {
        setViewEventModal(false);
    };

    const prepareModalDateRange = () => {
        const startMonth = selectedEvent && selectedEvent.event.extendedProps.startDate.split('-')[1];
        const startDate = selectedEvent && selectedEvent.event.extendedProps.startDate.split('-')[2];
        const endMonth = selectedEvent && selectedEvent.event.extendedProps.endDate.split('-')[1];
        const endDate = selectedEvent && selectedEvent.event.extendedProps.endDate.split('-')[2];
        const startTime = selectedEvent && selectedEvent.event.extendedProps.startTime;
        const endTime = selectedEvent && selectedEvent.event.extendedProps.endTime;

        return (
            <div className="calendar-modal__dates__task-date-range">
                <div className="calendar-modal__dates__task-date-range__text">시작</div>
                <div className="calendar-modal__dates__task-date-range__dates">{startMonth}월</div>
                <div className="calendar-modal__dates__task-date-range__dates">{startDate}일</div>
                <div className="calendar-modal__dates__task-date-range__dates">{startTime}</div>
                <div className="calendar-modal__dates__task-date-range__text">~</div>
                <div className="calendar-modal__dates__task-date-range__text">종료</div>
                <div className="calendar-modal__dates__task-date-range__dates">{endMonth}월</div>
                <div className="calendar-modal__dates__task-date-range__dates">{endDate}일</div>
                <div className="calendar-modal__dates__task-date-range__dates">{endTime}</div>
            </div>
        );
    };

    const removeEvent = () => {
        selectedEvent && selectedEvent.event.remove();
        setViewEventModal(false);
    };

    const editEvent = () => {
        if (selectedEvent) {
            navigate(`/calendar-add-event/${selectedEvent.event.extendedProps.id}`);
        }
    };

    return (
        <>
            <WithSideBarAndNavBar>
                <div className="calendar">
                    <div className="calendar__head">
                        <div className="calendar__head__text">캘린더</div>
                        <div className="calendar__head__button">
                            <Button label="+추가하기" type="type2" action={handleAddEvent} />
                        </div>
                    </div>
                    <div className="calendar__main" id="calendar">
                        <FullCalendar
                            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                            headerToolbar={{
                                left: 'prev title next',
                                center: '',
                                right: '',
                            }}
                            locale="ko"
                            initialView="dayGridMonth"
                            editable={true}
                            selectable={true}
                            selectMirror={true}
                            dayMaxEvents={true}
                            weekends={true}
                            initialEvents={INITIAL_EVENTS}
                            eventContent={renderEventContent}
                            eventClick={handleEventClick}
                        />
                    </div>
                </div>
                {viewEventModal && (
                    <div className="calendar-modal">
                        <div className="calendar-modal__popup">
                            <div className="calendar-modal__action">
                                <div className="calendar-modal__icons" onClick={removeEvent}>
                                    <TrashIcon />
                                </div>
                                <div className="calendar-modal__icons" onClick={editEvent}>
                                    <EditIcon />
                                </div>
                                <div className="calendar-modal__close" onClick={onCloseModal}>
                                    <Close />
                                </div>
                            </div>
                            <div className="calendar-modal__task-name">
                                <div className="calendar-modal__task-name__icon">
                                    <EllipseIcon />
                                </div>
                                <div className="calendar-modal__task-name__text">매장 대청소날</div>
                            </div>
                            <div className="calendar-modal__dates">{prepareModalDateRange()}</div>
                        </div>
                    </div>
                )}
            </WithSideBarAndNavBar>
        </>
    );
};
export default Calendar;
